import LocalizedStrings from 'react-localization';
import en from './locale/en.js';

const Strings = new LocalizedStrings({ en });

export default Strings;
